import { render, staticRenderFns } from "./ClientCustomerManager.vue?vue&type=template&id=37ce41fa&scoped=true"
import script from "./ClientCustomerManager.vue?vue&type=script&lang=js"
export * from "./ClientCustomerManager.vue?vue&type=script&lang=js"
import style0 from "./ClientCustomerManager.vue?vue&type=style&index=0&id=37ce41fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce41fa",
  null
  
)

export default component.exports